'use strict';

var recaptcha = require('../components/recaptcha');

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = {
    subscribeContact: function () {
        var $form = $('form.contact-us');
        var grecaptchav2_element = $form.find('.grecaptcha-v2');
        var grecaptchav2_responded = false;

        $form.submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            if (grecaptchav2_element.length && typeof grecaptcha != 'undefined') {
                var grecaptcha_id = grecaptchav2_element[0].dataset.grecaptchaID;
                var grecaptcha_response = grecaptcha.getResponse(grecaptcha_id);
                if (!grecaptcha_response) {
                    displayMessage({
                        success: false,
                        msg: grecaptchav2_responded ? 'Please wait or refresh the page' : 'Please check the box'
                    }, button);
                    return false;
                }

                grecaptchav2_responded = true;
                form.find('.recaptchaV2Token').remove();
                form.append($("<input type='hidden' class='form-control recaptchaV2Token' name='dwfrm_recaptcha_recaptchaV2Token' value=" + grecaptcha_response + ">"));

                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        displayMessage(data, button);
                        if (data.success) {
                            $('.contact-us').trigger('reset');
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        displayMessage(err, button);
                    }
                });
            } else {
                $.spinner().start();
                button.attr('disabled', true);
                recaptcha.check(e, {
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        displayMessage(data, button);
                        if (data.success) {
                            $('.contact-us').trigger('reset');
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        displayMessage(err, button);
                    }
                });
            }
        });
    }
};
